import * as React from "react";
import { Select, FormLabel } from "@cmsgov/design-system-core";
import { camelize } from "../services/Utility";
import "../styles/SelectYear.css";
export interface Props {
  selectedYear: string;
  label: string;
  onChange: (changed: string) => void;
  yearList: [];
}

function SelectYear({ selectedYear, label, onChange, yearList }: Props) {

  const choiceChanged = (event: any) => {
    onChange(event.target.value);
  };

  const years = (data: any) => {
    return <option key={data.value} value={data.value}>{data.label}</option>;
  };

  const mappedYearChoices = yearList.map(years);

  return (
    <div>
      <FormLabel>{label}
        <Select
          value={selectedYear}
          className="ds-u-font-weight--normal"
          size="medium"
          name={camelize(label)}
          label={label}
          onChange={choiceChanged}
        >
          {mappedYearChoices}
        </Select>
      </FormLabel>
  </div>
  );
}

export default SelectYear;
